import React from 'react'
import AuthRouter from 'routes/Components/AuthRouter'
import { Routes, Route } from 'react-router'

const Routers = ({ token, permissions }) => {
  const isAuthenticated = Boolean(token)
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <AuthRouter
            isAuthenticated={isAuthenticated}
            permissions={permissions}
          />
        }
      />
    </Routes>
  )
}

export default Routers
